import {useLocation} from '@github-ui/react-router'
import {useNavigate, useSearchParams} from '@github-ui/use-navigate'

export function useListResults() {
  const navigate = useNavigate()
  const location = useLocation()

  const [currentParams] = useSearchParams()
  const fetchedQuery = currentParams.get('q') || ''
  const currentPage = Number(currentParams.get('page')) || 1

  function fetchResults({q, page = 1}: {q: string; page?: number}) {
    const navigateParams = new URLSearchParams()

    if (q) {
      navigateParams.set('q', q)
    }

    if (page > 1) {
      navigateParams.set('page', page.toString())
    }

    const search = navigateParams.toString()
    navigate({
      pathname: location.pathname,
      search: search ? `?${search}` : '',
    })
  }

  return {fetchedQuery, currentPage, fetchResults}
}
